$(function() {
  $('#openlpmenu').on('click', function() {
    $('.lp').toggleClass('is-open');
  });
  
  $(window).on('load',function(){

	//ローディング処理
	$('.loading').fadeOut(1000);
    
	var bottomPoint = 200;
 	var scrollTag = ( window.chrome || "WebkitAppearance" in document.documentElement.style ) ? "body" : 	"html";
 	var scrollTop;
 	$( window ).on( "scroll", function( e ) {
		 scrollTop = $(window).scrollTop();
		 var clientHeight = $( window ).height();
		 var scrollBottom = $( window ).scrollTop() + $( window ).height();
		 $( ".animation" ).each( function() {
			 if ( $(this).offset().top > scrollBottom - bottomPoint ) {
				return;
			 }
			 if ( $(this).css( "opacity" ) != 0 ) { return; }
			 $(this).delay( 200 ).addClass('on');
		 } );
 	} ).trigger( "scroll" );
  });
});